import { render, staticRenderFns } from "./TX02.vue?vue&type=template&id=a6ffb696&"
import script from "./TX02.vue?vue&type=script&lang=js&"
export * from "./TX02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports